import { useEffect, useState } from "react";
import { Phone, Sparkles } from "lucide-react";
import { PHONE, PHONE_HREF } from "./site";
import { EstimateDialog } from "./EstimateDialog";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-[#0F172A]/8 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <img
            src="/images/logo-round.png"
            alt="His and Hers Cleaning Services and Handyman logo"
            className="w-11 h-11 rounded-full object-cover ring-1 ring-[#0F172A]/10 group-hover:ring-[#D96B43]/50 transition-all duration-300"
          />
          <span className="font-display text-lg leading-none text-[#0F172A]">
            His &amp; Hers
            <span className="block text-[10px] font-jet tracking-[0.25em] uppercase text-[#D96B43] mt-0.5">
              Cleaning + Handyman
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8 font-jet text-[11px] uppercase tracking-[0.2em] text-[#475569]">
          <a data-testid="nav-link-services" href="#services" className="hover:text-[#D96B43] transition-colors duration-300">Services</a>
          <a data-testid="nav-link-pricing" href="#pricing" className="hover:text-[#D96B43] transition-colors duration-300">Pricing</a>
          <a data-testid="nav-link-work" href="#work" className="hover:text-[#D96B43] transition-colors duration-300">Our Work</a>
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-phone-cta"
            href={PHONE_HREF}
            className="hidden sm:flex items-center gap-2 font-jet text-xs tracking-wider text-[#0F172A] hover:text-[#D96B43] transition-colors duration-300"
          >
            <Phone size={14} strokeWidth={2.2} />
            {PHONE}
          </a>
          <EstimateDialog
            testId="nav-estimate-button"
            label="Free Estimate"
            className="flex items-center gap-2 bg-[#0F172A] text-[#FDFBF7] text-xs font-jet uppercase tracking-[0.15em] px-4 py-2.5 rounded-full hover:bg-[#D96B43] transition-colors duration-300"
          />
          <Sparkles size={0} className="hidden" />
        </div>
      </div>
    </header>
  );
}
